import { useEffect, useState } from 'react';

interface LoaderScreenProps {
  onComplete: () => void;
}

const LoaderScreen = ({ onComplete }: LoaderScreenProps) => {
  const [showSubtitle, setShowSubtitle] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Show subtitle after logo appears
    const subtitleTimer = setTimeout(() => {
      setShowSubtitle(true);
    }, 400);

    // Wait for window to fully load
    const handleLoad = () => {
      // Add minimum display time of 1.5 seconds
      setTimeout(() => {
        setFadeOut(true);
        // Wait for fade-out animation to complete
        setTimeout(() => {
          onComplete();
        }, 500);
      }, 1500);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => {
      clearTimeout(subtitleTimer);
      window.removeEventListener('load', handleLoad);
    };
  }, [onComplete]);

  return (
    <div className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background transition-opacity duration-500 ${
      fadeOut ? 'opacity-0' : 'opacity-100'
    }`}>
      <div className="animate-fade-in">
        <h1 className="text-6xl md:text-8xl font-bold gradient-text mb-4">
          commodIT
        </h1>
      </div>
      
      <div 
        className={`transition-all duration-500 ${
          showSubtitle 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-xl md:text-2xl text-white font-bold tracking-wide">
          the pioneers of it
        </p>
      </div>
    </div>
  );
};

export default LoaderScreen;
